import Vue from 'vue';
import noty from './noty.service';

export default {
  async get() {
    return (await Vue.http.get('/api/settings/system')).data;
  },
  async save(systemSettings) {
    let s = (await Vue.http.post('/api/settings/system', systemSettings)).data;
    noty.success('Settings saved successfully');
    return s;
  }
}



// WEBPACK FOOTER //
// ./src/services/systemsettings.service.js